// extracted by mini-css-extract-plugin
export default {"team_feedback":"S1_TeamFeedback_team_feedback__DCpsS","description":"S1_TeamFeedback_description__8zGKY","name_designation":"S1_TeamFeedback_name_designation__k7bJl"};